import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static targets = ['toggleAll', 'item', 'submit'];
  static values = { url: String, labelTemplate: String };

  toggleAll() {
    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = this.toggleAllTarget.checked;
    });

    this.#renderSubmit();
  }

  updateSelection() {
    this.toggleAllTarget.checked = this.itemTargets.every((checkbox) => checkbox.checked);

    this.#renderSubmit();
  }

  #renderSubmit() {
    const count = this.checkedItems.length;

    this.submitTarget.textContent = this.labelTemplateValue.replace('NUM', count > 0 ? count : '');
    this.submitTarget.disabled = count === 0;
  }

  submit() {
    const body = new FormData();
    this.checkedItems.forEach((checkbox) => body.append('frs_ids[]', checkbox.value));

    const request = new FetchRequest('post', this.urlValue, {
      body,
      responseKind: 'turbo-stream',
    });

    this.submitTarget.disabled = true;

    request
      .perform()
      .then((response) => {
        if (!response.ok) {
          this.submitTarget.disabled = false;
          return;
        }

        this.dispatch('request-close', { prefix: 'turbo-modal', target: this.element });
      })
      .catch((error) => {
        this.submitTarget.disabled = false;
        console.error(error);
      });
  }

  get checkedItems() {
    return this.itemTargets.filter((checkbox) => checkbox.checked);
  }
}
